export interface UploadedMedia {
  uploadedMediaId: number;
  originalFileName: string;
  formattedFileName: string;
}

export function blankUploadedMedia(): UploadedMedia {
  return {
    uploadedMediaId: 0,
    formattedFileName: '',
    originalFileName: '',
  };
}

export function copyUploadedMedia(uploadedMedia: UploadedMedia): UploadedMedia {
  return {
    uploadedMediaId: uploadedMedia.uploadedMediaId,
    formattedFileName: uploadedMedia.formattedFileName,
    originalFileName: uploadedMedia.originalFileName,
  };
}
